export const adminPaymentTableHead = [
  {
    title: '#',
    name: 'userTransactionId',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Amount Paid',
    name: 'amount',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'User',
    name: 'user',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Type',
    name: 'transferType',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Date',
    name: 'createdAt',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Description',
    name: 'description',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
];
